import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { logSafeErrorWithoutCustomerData } from '@atlassian/jira-common-directory-v2/src/utils/log-safe-error';
import { VERSIONS_ERROR_ANALYTICS } from '../../../common/constants';
import { deleteAndSwapVersion } from '../../services/delete';
import { DELETE_VERSION, deletionSuccess, deletionFailure } from '../../state/actions';
import { getBaseUrl, getFields, getVersionId } from '../../state/selectors';
import type { State } from '../../state/types';

const LOG_LOCATION = 'project-directories.versions.delete-version.ops.delete';

export const epic = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action$: ActionsObservable<any>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
	action$.ofType(DELETE_VERSION).mergeMap(() =>
		Observable.fromPromise(
			deleteAndSwapVersion(
				getBaseUrl(store.getState()),
				getVersionId(store.getState()),
				getFields(store.getState()),
			),
		)
			.map(deletionSuccess)
			.catch((error) => {
				logSafeErrorWithoutCustomerData(error, LOG_LOCATION, VERSIONS_ERROR_ANALYTICS);
				return Observable.of(deletionFailure(error));
			}),
	);
